unable to read source [project]/momira.app/web/node_modules/src/core.ts